import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-compare-ionic-appflow-advantages-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './compare-ionic-appflow-advantages-section.component.html',
  styleUrl: './compare-ionic-appflow-advantages-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareIonicAppflowAdvantagesSectionComponent {}
